import React from 'react'
import styled from '@emotion/styled'

import {PaymentMethodType} from '@vio/core/src/api-types/bovio/response/payment_methods_settings'

interface Props {
  type: PaymentMethodType
  name?: string
  className?: string
  customStyle?: React.CSSProperties
}

const StyledImage = styled.img`
  vertical-align: middle;
`

/**
 * Displays the logo for a payment method type (e.g. Apple Pay, Google Pay, Klarna).
 * SVG assets are sourced from `@vio/atlas`.
 */
export const PaymentMethodLogo = ({
  type,
  name,
  className,
  customStyle
}: Props) => {
  return (
    <StyledImage
      width="20"
      src={
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        require(
          `@vio/atlas/src/foundation/logos/paymentServiceLogo/paymentMethodType/${type}.svg`
        ).default.src
      }
      style={customStyle}
      alt={name ?? type}
      className={className}
    />
  )
}
